export const cache = {
  state: {
    chats: [],
  },
  mutations: {
    updateChatsCache(state, cacheKey) {
      if (!state.chats.includes(cacheKey)) {
        state.chats.push(cacheKey)
      }
    },
  },
  actions: {
    updateChatsCache(context, cacheKey) {
      context.commit('updateChatsCache', cacheKey)
    },
  },
}
